<template>
  <div class="app-input-text" :class="{'el-form--inline': dialogName}">
    <div v-if="optionPrefix">{{optionPrefix}}</div>
    <el-input
      :type="typeOfInputElement"
      ref="input"
      v-model="model"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="computedDisabled"
      :class="optionClass"
      :maxlength="maxlength"
      @keydown.enter.native="onEnterKey($event)"
      @focus="onFocus"
      @blur="onBlur"
      @change="onChange"
      @clear="onClear"></el-input>
    <!-- ダイアログ表示ボタン -->
    <app-button-search-dialog v-if="dialogName" @click="$emit('app-event', 'dialog:' + dialogName)" :disabled="disabled"></app-button-search-dialog>
    <!-- /ダイアログ表示ボタン -->
    <div v-if="optionSuffix">{{optionSuffix}}</div>
  </div>
</template>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppInputComponent from './AppInputComponent';

@Component
export default class AppInputText extends AppInputComponent {
  // ボタン押下時のイベント名
  get dialogName () {
    return (this.options && 'dialogName' in this.options) ? this.options.dialogName : '';
  }

  // 2020/07追加
  get maxlength () {
    return (this.options && 'maxLength' in this.options) ? this.options.maxLength : null;
  }

  // 2021/01追加
  get typeOfInputElement () {
    return (this.options && 'typeOfInputElement' in this.options) ? this.options.typeOfInputElement : 'text';
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputText.vue